import { useState } from "react";
import { motion } from "framer-motion";

const ContactForm = () => {
  const [submitted, setSubmitted] = useState(false);

  const isSafeMessage = (msg) => {
    // Simple check for suspicious tags or scripts
    const lowerMsg = msg.toLowerCase();
    if (
      lowerMsg.includes("<script") || 
      lowerMsg.includes("</script>") || 
      lowerMsg.includes("<") || 
      lowerMsg.includes(">")
    ) {
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const message = e.target.message.value;

    if (!isSafeMessage(message)) {
      alert("Message contains invalid characters or scripts.");
      return;
    }
    const form = e.target;

    const data = new FormData(form);

    try {
      const res = await fetch("https://formspree.io/f/xqaqjpww", {
        method: "POST",
        body: data,
        headers: {
          Accept: "application/json",
        },
      });

      if (res.ok) {
        setSubmitted(true);
        form.reset();
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="relative">
      {submitted && (
        <div className="absolute inset-0 bg-white bg-opacity-90 flex items-center justify-center z-50 text-center p-6 rounded-xl shadow-xl">
          <div>
            <h2 className="text-2xl font-semibold text-green-600">Thank you!</h2>
            <p className="mt-2 text-gray-700">Your message has been received.<br />Our team will contact you soon.</p>
          </div>
        </div>
      )}

      <motion.form
        onSubmit={handleSubmit}
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 bg-gray-50 p-8 rounded-xl shadow-lg"
      >
        <div className="flex flex-col">
            <label className="mb-2 font-semibold">First Name</label>
            <input
            type="text"
            name="firstName"
            required
            placeholder="First name"
            pattern="^[A-Za-z\s\-]{2,30}$"
            title="Name should contain only letters, spaces, or hyphens (2-30 characters)"
            className="px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-schoolRed"
            />
        </div>
        <div className="flex flex-col">
            <label className="mb-2 font-semibold">Last Name</label>
            <input
            type="text"
            name="lastName"
            required
            placeholder="Last name"
            pattern="^[A-Za-z\s\-]{2,30}$"
            title="Name should contain only letters, spaces, or hyphens (2-30 characters)"
            className="px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-schoolRed"
            />
        </div>
        
        <div className="flex flex-col">
          <label className="mb-2 font-semibold">Email Address</label>
          <input
            type="email"
            name="email"
            required
            placeholder="you@example.com"
            pattern="^[^@\s]+@[^@\s]+\.[^@\s]+$"
            title="Please enter a valid email address"
            className="px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-schoolRed"
            />
        </div>
        <div className="flex flex-col">
        <label className="mb-2 font-semibold">Contact Number</label>
        <input
            type="tel"
            name="phone"
            required
            placeholder="e.g., 9876543210"
            pattern="[6-9]{1}[0-9]{9}"
            title="Please enter a valid 10-digit Indian mobile number starting with 6, 7, 8, or 9"
            className="px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-schoolRed"
        />
        </div>
        <div className="md:col-span-2 flex flex-col">
          <label className="mb-2 font-semibold">Message</label>
          <textarea
            name="message"
            rows="5"
            required
            placeholder="Write your message here..."
            pattern="^[\w\s.,!?'-]{10,500}$"
            title="Message should be between 10 and 500 characters and can contain letters, numbers, spaces, and common punctuation"
            className="px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-schoolRed"
          ></textarea>
        </div>
        <div className="md:col-span-2 text-center">
          <button
            type="submit"
            className="px-8 py-3 bg-[#0077CC] hover:bg-[#0196ad] text-white font-semibold rounded-full shadow-md transition"
          >
            Send Message
          </button>
        </div>
      </motion.form>
    </div>
  );
};

export default ContactForm;
